import React, { useEffect, useState } from 'react';
import useStyles from './style';
import { Box } from '@material-ui/core';
import Button from '../../../components/atoms/Button';
import Typography from '../../../components/atoms/Typography';
import AdCalenderCarousel from '../../../components/organism/AdCalenderCarousel/AdCalenderCarousel';
import fetchService from '../../../../services/FetchService';
import { get, toLower } from 'lodash';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { getUId, transformLink } from '../../../../utils/utility';
import { sectionMap } from './locators';
const SmartListSlider = (props) => {
  const [response, setResponse] = useState('')
  const { fields, appConfig, sitecoreContext, params } = props
  const classes = useStyles();
  const language = get(sitecoreContext, 'language', 'en');
  const title = get(props, 'fields.title.value', '');
  let cta = get(props, 'fields.seeMore', '');
  cta = transformLink(cta)

  const limit = get(fields, 'limit.value', '10')
  const filterValue = get(fields, 'contentType.fields.taxonomyKey.value', 'Events')
  const filterType = get(fields, 'filterType', []).map((val) => ({ key: toLower(val.fields.taxonomyKey.value), value: toLower(val.fields.searchKey.value) }))
  const result = get(response, 'data.data.results', []);
  const pageName = getPageName(props);
  const customADStyle = get(params, 'vad-filters', '') == 'true';
  const componentName = getComponentName(props);
  const uid = getUId(props)
  const isEventsLandingPage = get(sitecoreContext, 'route.name', '') == 'events';

  useEffect(() => {
    try {
      fetchService({
        url: `${appConfig.SMART_LIST_API}`,
        method: 'POST',
        data: {
          "contentType": filterValue,
          "language": language,
          "facetFields": [],
          "limit": Number(limit),
          "offset": 0,
          "filters": filterType,
          "isPreviewMode": false
        }
      })
        .then(response => {
          setResponse(response)
        })
    } catch (error) {
      console.log("error", error)
    }

  }, []);

  const setTextColor = (id) => {
    if (!sectionMap || !id) return '';

    switch (id) {
      case sectionMap.artsAndCulture:
        return 'textColorBlack';

      case sectionMap.sports:
        return 'textColorWhite';

      case sectionMap.familyAndLifestyle:
        return 'textColorBlack';

      case sectionMap.musicAndNightlife:
        return 'textColorWhite';

      default:
        return ''
    }
  }
  const EventsDualSliderVariant2Header = (props) => (
    <div className={'smartListSliderHeader'}>
      <Typography className={'eventsTitle'} variant={'h5'}>{props?.title} {customADStyle ? <span>{result.length} {getDictionaryText('ADEventsMobile')}</span> : ""}</Typography>
      <Button
        className={'eventsCTA desktop'}
        component="span"
        buttonType="default"
        field={cta}
        hasBorder={false}
        animateSettings={{
          willAnimate: false,
        }}
      />
    </div>
  );

  return (
    <div className={`${classes.SmartListSlider} ${customADStyle ? 'AdSmartList' : ''}`} uid={uid}>
      {result && result.length > 0 && <EventsDualSliderVariant2Header title={title} />}
      <div>
        <Button
          className={`eventsCTA mobile ${setTextColor(uid)}`}
          component="span"
          buttonType="default"
          field={cta}
          hasBorder={false}
          animateSettings={{
            willAnimate: false,
          }}
        />
        <div className={isEventsLandingPage ? 'adCalenderMain' : ''}>
          <AdCalenderCarousel {...props} result={result} pageName={pageName} componentName={componentName} language={language} title={title} customADStyle={customADStyle} />
        </div>
      </div>
    </div>
  )
}

export default withSitecoreContext()(SmartListSlider);
